import { call, put } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import {
    API_BASE_URL,
    getRequest,
    postRequest,
    putRequest,
    deleteRequest
} from '../../../api';

import {
    setEmailLoading,

    getAllEmailTemplatesSuccess,
    getAllEmailTemplatesFail,

    getEmailTemplateSuccess,
    getEmailTemplateFail,

    createEmailTemplateSuccess,
    createEmailTemplateFail,

    updateEmailTemplateSuccess,
    updateEmailTemplateFail,

    deleteEmailTemplateSuccess,
    deleteEmailTemplateFail,

    getEmailPlaceholdersSuccess,
    getEmailPlaceholdersFail,

    previewEmailTemplateSuccess,
    previewEmailTemplateFail,

    sendAccountActivationSuccess,
    sendAccountActivationFail,

    getEmailLogsSuccess,
    getEmailLogsFail,
    requestPasswordResetSuccess,
    requestPasswordResetFail,
    confirmPasswordResetSuccess,
    confirmPasswordResetFail,
} from '../actions/emailActions';

// =========================
// Templates
// =========================
export function* getAllEmailTemplatesSaga() {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/email-templates`;

    yield put(setEmailLoading(true));

    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getAllEmailTemplatesSuccess(resp.data));
        yield put(setEmailLoading(false));
    } catch (error) {
        yield put(getAllEmailTemplatesFail(error.message));
        yield put(setEmailLoading(false));
    }
}

export function* getEmailTemplateSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/email-templates/${action.payload.id}`;

    yield put(setEmailLoading(true));

    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getEmailTemplateSuccess(resp.data));
        yield put(setEmailLoading(false));
    } catch (error) {
        yield put(getEmailTemplateFail(error.message));
        yield put(setEmailLoading(false));
    }
}

export function* createEmailTemplateSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/email-templates`;
    const data = action.payload;

    yield put(setEmailLoading(true));

    try {
        const resp = yield call(postRequest, { url, data, token });
        yield put(createEmailTemplateSuccess(resp.data));
        yield put(setEmailLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: 'Template email créé avec succès',
            timer: 2000,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(createEmailTemplateFail(error.message));
        yield put(setEmailLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: 'Erreur lors de la création du template',
            timer: 2500,
            showConfirmButton: false
        });
    }
}

export function* updateEmailTemplateSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/email-templates/${action.payload.id}`;
    const data = action.payload.templateData;

    yield put(setEmailLoading(true));

    try {
        const resp = yield call(putRequest, { url, data, token });
        yield put(updateEmailTemplateSuccess(resp.data));
        yield put(setEmailLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: 'Template email mis à jour avec succès',
            timer: 2000,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(updateEmailTemplateFail(error.message));
        yield put(setEmailLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: 'Erreur lors de la mise à jour du template',
            timer: 2500,
            showConfirmButton: false
        });
    }
}

export function* deleteEmailTemplateSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/email-templates/${action.payload.id}`;

    yield put(setEmailLoading(true));

    try {
        yield call(deleteRequest, { url, token });
        yield put(deleteEmailTemplateSuccess(action.payload.id));
        yield put(setEmailLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: 'Template email supprimé avec succès',
            timer: 2000,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(deleteEmailTemplateFail(error.message));
        yield put(setEmailLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: 'Erreur lors de la suppression du template',
            timer: 2500,
            showConfirmButton: false
        });
    }
}

// =========================
// Placeholders / Preview
// =========================
export function* getEmailPlaceholdersSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/email-templates/placeholders/${action.payload.contextType}`;

    yield put(setEmailLoading(true));

    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getEmailPlaceholdersSuccess(resp.data));
        yield put(setEmailLoading(false));
    } catch (error) {
        yield put(getEmailPlaceholdersFail(error.message));
        yield put(setEmailLoading(false));
    }
}

export function* previewEmailTemplateSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/email-templates/preview/${action.payload.templateCode}`;
    const data = action.payload.variables || {};

    yield put(setEmailLoading(true));

    try {
        const resp = yield call(postRequest, { url, data, token });
        yield put(previewEmailTemplateSuccess(resp.data));
        yield put(setEmailLoading(false));
    } catch (error) {
        yield put(previewEmailTemplateFail(error.message));
        yield put(setEmailLoading(false));
    }
}

// =========================
// Account activation
// =========================
export function* sendAccountActivationSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/users/account-activation`;
    const uid = sessionStorage.getItem("uid");
    const data = {
        username: action.payload.username
    };

    try {
        const resp = yield call(postRequest, { url, data, token });

        yield put(sendAccountActivationSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: resp?.data?.message || 'Email d’activation envoyé avec succès',
            timer: 2500,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(sendAccountActivationFail(error?.response?.data.message));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: error?.response?.data?.message || 'Erreur lors de l’envoi de l’email d’activation',
            timer: 3000,
            showConfirmButton: false
        });
    }
}

// =========================
// Logs
// =========================
export function* getEmailLogsSaga() {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/email-logs`;

    yield put(setEmailLoading(true));

    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getEmailLogsSuccess(resp.data));
        yield put(setEmailLoading(false));
    } catch (error) {
        yield put(getEmailLogsFail(error.message));
        yield put(setEmailLoading(false));
    }
}

export function* requestPasswordResetSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/password-reset/request`;
    const data = {
        identifier: action.payload.identifier
    };

    try {
        const resp = yield call(postRequest, { url, data, token });
        yield put(requestPasswordResetSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: resp?.data?.message || 'Si le compte existe, un email a été envoyé.',
            timer: 2800,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(requestPasswordResetFail(error.message));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: error.message || 'Erreur lors de la demande de réinitialisation',
            timer: 3000,
            showConfirmButton: false
        });
    }
}

export function* confirmPasswordResetSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/password-reset/confirm`;
    const data = {
        token: action.payload.token,
        newPassword: action.payload.newPassword,
        confirmPassword: action.payload.confirmPassword,
    };

    try {
        const resp = yield call(postRequest, { url, data, token });
        yield put(confirmPasswordResetSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: resp?.data?.message || 'Mot de passe réinitialisé avec succès.',
            timer: 2500,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(confirmPasswordResetFail(error.message));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: error.message || 'Erreur lors de la réinitialisation du mot de passe',
            timer: 3000,
            showConfirmButton: false
        });
    }
}